// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"760e773e","917":"4c3b42ab"}[chunkId] + ".chunk.js";
};